import { ModalCustom } from "components/ModalCustom";
import { Icone, ModalBody } from "./style";
import { FaExclamation } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: () => void;
}

export function ModalCertezaRemoverProcessoLote({
  show,
  handleClose,
  onConfirm,
}: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Remover processos"
      centered={true}
      footer={true}
      footerConfirmButton={true}
      onConfirm={onConfirm}
      confirmButtonText="Remover"
    >
      <ModalBody>
        <Icone>
          <FaExclamation />
        </Icone>
        Deseja remover o(s) processo(s) selecionado(s) deste lote de licenciamentos?
      </ModalBody>
    </ModalCustom>
  );
}
